import { useEffect, useState } from "react";

const MOBILE_REGEX = /android|iphone|ipad|ipod|mobile|tablet/i;

export const useIsMobileDevice = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  useEffect(() => {
    if (typeof navigator === "undefined") return;
    setIsMobileDevice(MOBILE_REGEX.test(navigator.userAgent));
  }, []);

  return isMobileDevice;
};
